function animateScore(element, start, end, timer) {
    if (start !== end) {
        let range     = end - start;
        let current   = start;
        let increment = (end > start) ? 1 : -1;
        let stepTime  = Math.abs(Math.floor(timer / range));

        let timer = setInterval(() => {
            current += increment;
            element.innerHTML = current;

            if (current === end) {
                clearInterval(timer);
            }
        }, stepTime);
    } else if (start !== end) {
        element.innerHTML = end;
    }
}

module.exports = animateScore;